import {
  BatchType,
  CtBatchSource,
  CtBatchState,
  CtDocument,
  CtPage,
  EingangCtBatch,
  EingangTyp,
  ProofCtBatch,
  TaskCtBatch,
} from '../model/ct-batch-model';
import dayjs from 'dayjs';
import { DocumentClassKey } from '../document-classes/document-classes';

export const defaultProofCtBatch: ProofCtBatch = {
  id: 'batch-id',
  auditId: 'audit-id',
  auditRequestId: 'request-id',
  tenant: 'tenant',
  proofType: 'proof-typ',
  claimNumber: 'schaden123',
  businessTransaction: 'BT',
  state: CtBatchState.SPLITTING,
  timestamp: dayjs('2020-01-01').toDate(),
  orderDescription: 'nicer-dicer',
  documents: [getDefaultDocument()],
  domain: 'PROOF',
  batchType: BatchType.PROOF,
  source: CtBatchSource.LEGACY,
  receivedAfterSubmission: false,
};

export const defaultEingangCtBatch: EingangCtBatch = {
  id: 'batch-id',
  eingangId: 'eingang-id',
  type: EingangTyp.EMAIL,
  tenant: 'tenant',
  state: CtBatchState.SPLITTING,
  timestamp: dayjs('2020-01-01').toDate(),
  documents: [getDefaultDocument()],
  domain: 'PROOF',
  batchType: BatchType.EINGANG,
  source: CtBatchSource.NEW_BACKEND,
};

export const defaultTaskCtBatch: TaskCtBatch = {
  id: 'batch-id',
  taskId: 'task-id',
  tenant: 'tenant',
  state: CtBatchState.SPLITTING,
  timestamp: dayjs('2020-01-01').toDate(),
  documents: [getDefaultDocument()],
  domain: 'PROOF',
  batchType: BatchType.TASK,
  source: CtBatchSource.NEW_BACKEND,
};

export function getDefaultDocument(
  documentClasses: DocumentClassKey[] = ['25_Q3_RECHNUNG'],
): CtDocument {
  return {
    index: 0,
    id: 'doc-1',
    documentClasses,
    pages: [
      {
        id: 'page1',
      } as CtPage,
      {
        id: 'page2',
      } as CtPage,
    ],
    originalFileIndex: 0,
  };
}
